export default __webpack_public_path__ + "static/media/Belt of the Blood Drinker.b5c0b46e.jpg";